import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { FlightOffersList } from './ui/flight_offers.js';

export { FlightOffersList } from './ui/flight_offers.js';

/** Entrada de catálogo do `flight_offers` (slot chat). O card interativo expande
 *  as tarifas inline (port `flightTariff`) e despacha o pick estruturado
 *  (`interaction` / `select_offer_fares`); `onQuickReply` segue como único
 *  caminho de `reply` (drawer de filtro, one-way). */
export const flightOffersEntry: GenUiEntry<Extract<ChatUi, { kind: 'flight_offers' }>> = {
  kind: 'flight_offers',
  slot: 'chat',
  policy: {
    productOf: () => 'flight',
    // Congelamento INTRÍNSECO: bloco com escolha ecoada é recibo, não escolha.
    // A alternativa (`resolvedInteractionIds`) é best-effort e persiste DEPOIS
    // da publicação do evento — pode render um frame clicável. Ela fica como
    // CINTO, não como suspensório.
    frozenWhen: (ui) => ui.chosen !== undefined,
  },
  render: ({ ui, note, readOnly, dispatch }) => (
    <FlightOffersList
      offers={ui.offers}
      allOffers={ui.allOffers}
      challengeId={ui.challengeId}
      autoExpand={ui.autoExpand}
      search={ui.search}
      {...(ui.chosen ? { chosen: ui.chosen } : {})}
      note={note}
      readOnly={readOnly}
      dispatch={dispatch}
      onQuickReply={
        readOnly
          ? undefined
          : (text) => {
              dispatch({ type: 'reply', text });
            }
      }
    />
  ),
};
